<template>
  <div style="min-height:200px" v-loading="loading">
    <!-- 二级层级 -->
    <div v-if="level == 20">
      <div v-for="item in content">
        <!-- 一般 -->
        <template v-if="item.show_type == CONTENT_TYPE_NORMAL && item.arr">
          <all-render
            :contentId="item.arr[0].content_id"
            :dealId="item.arr[0].deal_id"
            :dataId="item.arr[0].dataId"
            :query="item.arr[0].query"
            :iden="item.arr[0].iden"
            :showType="item.arr[0].show_type"
            :level="level"
            @setFilterQuery="setFilterQuery"
            @sendParams="sendParams"
            @saveCallback="saveCallback">
          </all-render>
        </template>
        <!-- 一般 -->
        <!-- Tab -->
        <template v-if="item.show_type == CONTENT_TYPE_TAB && item.arr">
          <el-tabs v-model="item.activeName" @tab-click="handleClick(item)">
            <el-tab-pane v-for="tab in item.arr" :label="tab.name" :name="tab.name">
              <div style="min-height:100px" v-loading="loading" v-if="tab.rendered">
                <all-render
                  :contentId="tab.content_id"
                  :dealId="tab.deal_id"
                  :dataId="tab.dataId"
                  :query="tab.query"
                  :iden="tab.iden"
                  :showType="tab.show_type"
                  :level="level"
                  @setFilterQuery="setFilterQuery"
                  @sendParams="sendParams"
                  @saveCallback="saveCallback">
                </all-render>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
        <!-- Tab -->
      </div>
    </div>
    <!-- 二级层级 -->
    <!-- 一级层级 -->
    <div v-if="level == 10">
      <all-render
        :contentId="contentId"
        :dealId="dealId"
        :dataId="dataId"
        :query="query"
        :iden="iden"
        :showType="showType"
        @setFilterQuery="setFilterQuery"
        @sendParams="sendParams"
        @saveCallback="saveCallback">
      </all-render>
    </div>
    <!-- 一级层级 -->
    <div style="display:inline-block" v-if="level==20" class="m-t-20">
      <el-button @click="goback"  v-if="!isDialog">返回</el-button>
    </div>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  import allRender from './allRender'
  import base64 from 'base-64'
  import utf8 from 'utf8'
  export default {
    data() {
      return {
        contentName: '',
        contentId: '',
        dealId: '',
        dataId: '',
        showType: 0,
        level: 0,
        activeName: '',
        tabs: [],
        tabsByName: {},
        loading: false,
        content: [],
        iden: '',
        query: {},
        routeQuery: {},
        isJump: 0,
        notReload: false,
        showBackBtn: false,
        data_model: 0,
        currentFullScreenIndex: -1, // 当前全屏的功能集index
        isRenderPropsType: false, // 组件调用是否是通过 props 默认false
        isShowBackBtn: false
      }
    },
    methods: {
      getTabDetail() {
        this.currentFullScreenIndex = -1
        this.loading = true
        let input = {}
        if (this.isRenderPropsType) { // 由于通过任务弹窗触发，后端拿不到所需的功能点数据，特加上
          input = {
            params: {
              deal_id: this.renderPropsData.params.dealId
            }
          }
        }
        this.apiGet(`cms/contents/render/${this.contentId}`, input).then((res) => {
          this.fullLoading = false
          if (res.code == 200) {
            this.level = res.data.level
            this.showType = res.data.show_type
            this.dealId = res.data.deal_id
            this.iden = res.data.iden
            this.contentName = res.data.name
            this.data_model = res.data.data_model
            _g.setDocumentTitle(this.contentName)
            let queryStr = _g.fixBase64(this.routeQuery.query)
            let decodeStr = utf8.decode(base64.decode((queryStr)))
            if (!_g.isRealEmpty(queryStr)) {
              try {
                queryStr = JSON.parse(decodeStr)
              } catch (e) {
                queryStr = decodeStr
              }
            }
            if (this.level == 20 && !_g.isRealEmpty(res.data.content)) {
              _(res.data.content).forEach((item, index) => { // 功能集
                if (item.arr && item.arr.length) {
                  item.activeName = ''
                  let tabName = this.$route.query.tabName
                  if (!_g.isRealEmpty(tabName)) {
                    tabName = JSON.parse(utf8.decode(base64.decode(tabName)))
                  }
                  let activeIndex = 0
                  _(item.arr).forEach((content, key) => {
                    let query = {
                      query: '',
                      is_jump: this.isJump,
                      filterQuery: ''
                    }
                    let needSetFilterQuery = false
                    if (!_g.isRealEmpty(tabName) && content.name == tabName[index]) {
                      activeIndex = key
                      needSetFilterQuery = true
                    } else if (item.arr.length == 1 ||
                              (key == 0 && _g.isRealEmpty(tabName))) {  // 不是tab、或默认选中第一个的情况
                      needSetFilterQuery = true
                    }
                    let keyNumber = 0
                    if (_.isObject(queryStr)) { // 如果是对象
                      for (let i in queryStr) {
                        keyNumber++
                        if (content.content_id == i) {
                          // queryStr[i] = queryStr[i].substr(0, queryStr[i].length - 1)
                          query.query = base64.encode(utf8.encode(queryStr[i])) // 进行base64转码
                        }
                      }
                      // 是否为2级功能集并且是自定义按钮的判断操作
                      if (keyNumber < 2) {
                        for (let i in queryStr) {
                          if (res.data.id == i) {
                            query.query = base64.encode(utf8.encode(queryStr[i])) // 进行base64转码
                          }
                        }
                      }
                      keyNumber = 0
                    } else {
                      query.query = base64.encode(utf8.encode(queryStr))
                    }
                    if (needSetFilterQuery) {
                      query.filterQuery = this.routeQuery.filterQuery
                    }
                    content.rendered = false
                    content.dataId = this.dataId
                    content.query = query
                  })
                  item.activeName = item.arr[activeIndex].name
                  item.arr[activeIndex].rendered = true
                }
              })
            } else if (this.level == 10) {  // 针对普通页面
              let query = {
                query: '',
                is_jump: this.isJump,
                filterQuery: this.routeQuery.filterQuery
              }
              if (_.isObject(queryStr)) { // 如果是对象
                if (!_g.isRealEmpty(queryStr[this.contentId])) {
                  query.query = base64.encode(utf8.encode(queryStr[this.contentId]))
                } else if (!_g.isRealEmpty(queryStr[0])) {
                  query.query = base64.encode(utf8.encode(queryStr[0]))
                }
              } else if (!_g.isRealEmpty(queryStr)) {
                query.query = base64.encode(utf8.encode(queryStr))
              }
              this.query = query
            }
            this.content = res.data.content
          } else {
            _g.dealError(this, res)
          }
          this.loading = false
        })
      },
      setLoading(value) {
        this.loading = value
      },
      saveCallback(isSuccess) {
        if (isSuccess) {
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1500)
        }
      },
      resetData() {
        this.level = 0
        this.tabs = []
        this.showType = 0
        this.dealId = 0
        this.content = []
      },
      handleClick(item) { // 切换tab
        let activeName = item.activeName
        _(item.arr).forEach((content) => {
          if (activeName == content.name) {
            content.rendered = true
            return false
          }
        })
      },
      sendParams(queryArr) {  // 获取传给同页一级功能集的参数
        if (queryArr) {
          _(queryArr).forEach((res) => {
            _(this.content).forEach((item) => {
              _(item.arr).forEach((content) => {
                if (res.contentId == content.content_id) {
                  content.dataId = res.query.dataId
                  content.query = { query: res.query.query, is_jump: res.query.is_jump }
                }
              })
            })
          })
        }
      },
      setFilterQuery(queryData, index) {  // 设置列表的筛选参数
        console.log('render setFilterQuery = ', _g.s2j(_g.j2s(queryData)))
        // if (this.level == 10) { // 一级
        let query = _.cloneDeep(this.$route.query)
        if (_g.isRealEmpty(query)) {
          query = {}
        }
        let filterQuery = {}
        if (!_g.isRealEmpty(query.filterQuery)) {
          filterQuery = JSON.parse(utf8.decode(base64.decode(query.filterQuery)))
        } else {
          filterQuery = {}
        }
        filterQuery[index] = queryData
        filterQuery = base64.encode(utf8.encode(JSON.stringify(filterQuery)))
        if (filterQuery.length < 2083) {  // 防止json解析报错
          query.filterQuery = filterQuery
        }
        this.notReload = true
        router.push({
          path: this.$route.path,
          query: query
        })
      },
      goback() {
        router.go(-1)
      },
      setParamsByRoute(route) { // 根据路由设置参数
        this.contentId = route.params.contentId
        if (route.query.dataId) {
          this.dataId = route.query.dataId
        } else {
          this.dataId = 0
        }
        let queryString = ''
        let filterQuery = ''
        if (route.query.is_jump) {
          this.isJump = parseInt(route.query.is_jump)
        } else {
          this.isJump = 0
        }
        if (route.query.query) {
          queryString = route.query.query
        } else {
          queryString = ''
        }
        if (route.query.filterQuery) {
          filterQuery = route.query.filterQuery
        } else {
          filterQuery = ''
        }
        this.routeQuery = {
          query: queryString,
          is_jump: this.isJump,
          filterQuery: filterQuery
        }
      }
    },
    created() {
      this.setParamsByRoute(this.$route)
      this.getTabDetail()
    },
    watch: {
      $route(to, from) { // 监听路由改变
        // this.contentId = parseInt(to.params.contentId)
        // if (to.query.dataId) {
        //   this.dataId = parseInt(to.query.dataId)
        // } else {
        //   this.dataId = 0
        // }
        if (this.notReload &&
            this.contentId == to.params.contentId) {  // 只是切换tab，不重新请求
          this.notReload = false
          return
        }
        if (this.isRenderPropsType) {
          return
        }
        this.setParamsByRoute(to)
        this.resetData()
        this.getTabDetail()
      }
    },
    components: {
      allRender
    },
    mixins: [http, cmsConfig]
  }
</script>



// WEBPACK FOOTER //
// render.vue?c3669730